import { Box, Typography } from '@mui/material'
import { aboutTeamMembers } from '../../data/aboutContent'
import { MOBILE_MQ } from '../../theme/mobileLayout'

function TeamMemberCard({ member }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 210,
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0px 0px 4.913px 0px rgba(0,0,0,0.12)',
          bgcolor: 'rgba(8, 39, 83, 0.08)',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src={member.image}
          alt={member.name}
          sx={{
            position: 'absolute',
            left: '50%',
            top: member.objectPosition === 'bottom' ? 'auto' : 0,
            bottom: member.objectPosition === 'bottom' ? 0 : 'auto',
            transform: `translateX(-50%)${member.imageTransform ? ` ${member.imageTransform}` : ''}`,
            width: '100%',
            minWidth: '100%',
            height: member.objectPosition === 'bottom' ? 'auto' : '100%',
            maxHeight: '125%',
            objectFit: 'cover',
            objectPosition: member.objectPosition || 'center',
            display: 'block',
          }}
        />
      </Box>
      <Typography
        sx={{
          fontSize: 16,
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {member.name}
      </Typography>
    </Box>
  )
}

export default function MeetOurTeamMobile() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography
          component="h2"
          sx={{
            fontSize: 26,
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            [MOBILE_MQ]: { fontSize: 26 },
          }}
        >
          Meet Our Team
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
          }}
        >
          The dedicated leaders and visionaries driving Disha Foundation&apos;s mission forward.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '12px',
          width: '100%',
        }}
      >
        {aboutTeamMembers.map((member) => (
          <TeamMemberCard key={member.name} member={member} />
        ))}
      </Box>
    </Box>
  )
}
